const applications = {
  "Client applications": "Client applications",
  pageDescription: `A client application contains the code you write so that you can access the Volt API.
You can create as many client applications as you need, using different credentials.
For example, your website and mobile apps would normally be classed as different client applications.`,
  "Application details": "Application details",
  productionApplicationDetailsHelp:
    "Let us know when you're done testing and ready to start making real payments using the Volt API.",
  "Application name": "Application name",
  "Notifications for incomplete": "Notifications for incomplete",
  "Production environment": "Production environment",
  notificationsForIncompleteNo: `<0>No</0> (default) - notifications will be sent
for successful payments only`,
  notificationsForIncompleteYes: `<0>Yes</0> - notifications will be sent also for incomplete payments`,
  environmentActive:
    "<0>Active</0> - this application can be used to make payments",
  environmentInactive:
    "<0>Inactive</0> - this application cannot be used to make payments",
  Production: "Production",
  Sandbox: "Sandbox",
  Credentials: "Credentials",
  "Return URLs": "Return URLs",
  Notifications: "Notifications",
  credentialsHelp: `These are the credentials which will allow your application access to the Volt Open Banking API.
If your secret becomes compromised, you may generate a new secret at any time.`,
  "Production return URLs": "Production return URLs",
  returnUrlsHelp: `Where your customer will be redirected after making a payment.
You can use the same URL for two or all three states if you prefer.
The payload sent to the URL will be the same except for the status parameter.`,
  "Production notifications": "Production notifications",
  notificationsHelp: `The notification URL is where we send an HTTP POST to let you know the payment status, before we redirect your user.
You should never accept a payment as processed unless you receive a success notification for that payment.`,
  "Add a new application": "Add a new application",
  "New application": "New application",
  "Client ID": "Client ID",
  "Client secret": "Client secret",
  "Generate a new client secret": "Generate a new client secret",
  "On payment success": "On payment success",
  "On payment failure": "On payment failure",
  "Notification URL (https)": "Notification URL (https)",
  "Notification status": "Notification status",
  "Last successful notification": "Last successful notification",
  "Notifications queued": "Notifications queued",
  "Send a test to restart notifications":
    "Send a test to restart notifications",
  generateNewKeyConfirmationTitle:
    "Do you want to generate a new client secret?",
  generateNewKeyConfirmationMessage:
    "Current credentials will be invalidated immediately.",
  Generate: "Generate",
  "Fetching notifications status failed":
    "Fetching notifications status failed",
  "Create new application": "Create new application",
  deleteApplicationConfirmationTitle: "Delete application",
  deleteApplicationConfirmationMessage:
    "Application will be deleted immediately and permanently. Do you want to delete the application?",
  "Save application": "Save application",
  acceptsPaymentsFrom: "Application accepts payments from",
};

export default applications;
